import React, { useCallback } from "react";
import MappedNav from "./MappedNav";
import { connect } from "react-redux";
import { pmaActions } from "../../../_store/_actions";
import { SetNavbarDataInStorage } from "common/storage";
import { propertyUtil } from "../PropertyUtil";
import compose from "recompose/compose";
import styles from "./styles";
import { withStyles } from '@mui/styles';
import { withRouter } from "common/utils/router.util";

const PMANavbar = (props) => {
  const {
    mlsAreas,
    currentArea: currentAreaProp,
    isLoading,
    navbarData,
    handleDrawerOpen,
    currentPeriod,
    propertyData,
    agentData,
    version,
    typeOfMQVersion,
    typeOfQVersion,
    mailingVersion,
    showUnapprovedBox,
    unapprovedAreaCount,
    enableMailProApprovalProcess,
    isDataVerification,
    isUnavailable,
  } = props;

  // Always derive the freshest area data from the mlsAreas list — the
  // currentArea prop can lag behind Redux when areas are switched rapidly.
  const currentArea = propertyUtil.getCurrentArea(mlsAreas, currentAreaProp);

  /**
   * Switches the active area and loads all required mailer/PMA data for it.
   * Also used by the approval auto-switch flow (approvalSwitchStepAreaFn) —
   * if changing the index logic here, update getOneUnapprovedAreaData in
   * PropertyUtil as well since it mirrors the same ordering.
   */
  const changeCurrentArea = useCallback(async (index, area, listgenUserID) => {
    const date = new Date();
    const thisYear = date.getFullYear();
    const thisMonth = `${date.getMonth() + 1}`.padStart(2, "0");
    const today = `${date.getDate()}`.padStart(2, "0");
    const { mlsAreaID, mlsCityID } = area;
    const cityAndDate = `${mlsCityID}-${thisYear}-${thisMonth}-${today}`;

    props.resetLocalMailProRefFn && props.resetLocalMailProRefFn();
    await props.changeLoading(true);
    await props.switchArea(area, true);

    const isMailpro = window.location.href.includes("/mailpro");
    setTimeout(async () => {
      if (isMailpro) {
        props.history.push(`/mailpro/${mlsAreaID}`);
      } else {
        await props.getMailerProDetails(
          mlsAreaID,
          cityAndDate,
          agentData,
          true,
          version,
          typeOfMQVersion,
          typeOfQVersion,
          listgenUserID,
          false,
          false,
          false,
          true
        );
        props.history.push(`/pma/${mlsAreaID}`);
      }
      props.resetNewMailProInitDialogFn();
      if (area) {
        SetNavbarDataInStorage(area);
      }
    }, 500);
  }, [agentData, version, typeOfMQVersion, typeOfQVersion]);

  const handleSwitchStep = useCallback(async (step) => {
    props.resetLocalMailProRefFn && props.resetLocalMailProRefFn();
    props.switchStep(step);
    const isPmaEditor = window.location.href.includes("/pma");
    if (isPmaEditor || step === 0) {
      props.resetNewMailProInitDialogFn();
    }
  }, []);

  if (!navbarData && !isDataVerification) {
    return <div>Loading..</div>;
  }

  return (
    <div id="pma-modal-overlay-root">
      <MappedNav
        currentArea={currentArea}
        mlsAreas={mlsAreas}
        changeCurrentArea={changeCurrentArea}
        handleSwitchStep={handleSwitchStep}
        currentStep={props.currentStep}
        handleDrawerOpen={handleDrawerOpen}
        currentPeriod={currentPeriod}
        propertyData={propertyData}
        agentData={agentData}
        isLoading={isLoading}
        version={version}
        mailingVersion={mailingVersion}
        showUnapprovedBox={showUnapprovedBox}
        unapprovedAreaCount={unapprovedAreaCount}
        enableMailProApprovalProcess={enableMailProApprovalProcess}
        // NavbarFilterBox must stay mounted during anniversary mode so the
        // approval button doesn't reset to "Please Wait..." when the dialog closes.
        explicitEnableNewMailProInit={
          props.explicitEnableNewMailProInit &&
          props.newMailProInitDialogMode !== 'newAnniversary'
        }
        handleExplicitNewMailingScreen={props.explicitEnableNewMailProInitFn}
        resetNewMailProInitDialogFn={props.resetNewMailProInitDialogFn}
        isUnavailable={isUnavailable}
        isMailProLocked={props.isMailProLocked}
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    isLoading: state.pma.isLoading,
    currentVersion: state.pma.currentVersion,
    currentStep: state.pma.currentStep,
    currentPeriod: state.pma.currentPeriod,
    mlsAreas: state.pma.mlsAreas,
    pma: state.pma,
    pmaData: state.pma.pmaData,
    propertyData: state.pma.propertyData,
    version: state.pma.version,
    typeOfMQVersion: state.pma.typeOfMQVersion,
    typeOfQVersion: state.pma.typeOfQVersion,
    typeOfYEVersion: state.pma.typeOfYEVersion,
    mailingVersion: state.pma.mailingVersion,
    explicitEnableNewMailProInit: state.pma.explicitEnableNewMailProInit,
    newMailProInitDialogMode: state.pma.newMailProInitDialogMode, // used to keep NavbarFilterBox mounted during anniversary
  };
}

function mapDispatchToProps(dispatch) {
  return {
    switchVersion: (version) => dispatch(pmaActions.switchVersion(version)),
    switchStep: (step) => dispatch(pmaActions.switchStep(step)),
    switchArea: (area, isLoading) =>
      dispatch(pmaActions.switchArea(area, isLoading)),
    getCityAreaMap: (countyID, index) =>
      dispatch(pmaActions.getCityAreaMap(countyID, index)),
    getNavbarInfo: (listgenUserID) =>
      dispatch(pmaActions.getNavbarInfo(listgenUserID)),
    getMailerProDetails: (
      areaId, cityAndDate, agentData, forEditor, version,
      typeOfMQVersion, typeOfQVersion, listgenUserID,
      typeOfYEVersion, isDataVerification, specialHO, switchingStep
    ) => {
      dispatch(pmaActions.getMailerProDetails(
        areaId, cityAndDate, agentData, forEditor, version,
        typeOfMQVersion, typeOfQVersion, listgenUserID,
        typeOfYEVersion, isDataVerification, specialHO, switchingStep
      ));
    },
    getMailProMailerData: (areaId, agentData) =>
      dispatch(pmaActions.getMailProMailerData(areaId, agentData)),
    changeLoading: (status) => {
      dispatch(pmaActions.changeLoading(status));
    },
    getMarketActivity: (areaAndDate) => {
      dispatch(pmaActions.getMarketActivity(areaAndDate));
    },
    getPMACoverPhotoDetails: (cityID) => {
      dispatch(pmaActions.getPMACoverPhotoDetails(cityID));
    },
    qAreaAndCityDetails: (mlsAreaID, cityAndDate, subdivision) => {
      dispatch(pmaActions.qAreaAndCityDetails(mlsAreaID, cityAndDate, subdivision));
    },
    getMQCityDetails: (cityAndDate) => {
      dispatch(pmaActions.getMQCityDetails(cityAndDate));
    },
    getMQ2CityDetails: (cityAndDate, subdivision, listgenUserID) => {
      dispatch(pmaActions.getMQ2CityDetails(cityAndDate, subdivision, listgenUserID));
    },
    updateNavbar: (mlsAreas) => dispatch(pmaActions.updateNavbar(mlsAreas)),
    getQuarterAreaTable: (areaAndDate) => {
      dispatch(pmaActions.getQuarterAreaTable(areaAndDate));
    },
    getQuarterCityTable: (cityAndDate) => {
      dispatch(pmaActions.getQuarterCityTable(cityAndDate));
    },
    getSalePriceForCities: (date) => {
      dispatch(pmaActions.getSalePriceForCities(date));
    },
    getYearEndDetails: (date, listgenUserID) => {
      dispatch(pmaActions.getYearEndDetails(date, listgenUserID));
    },
    resetNewMailProInitDialogFn: () =>
      dispatch(pmaActions.resetNewMailProInitDialogFn()),
  };
}

const enhance = compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
);

export default React.memo(enhance(PMANavbar));
